import * as React from 'react'
import SubmitButton from './submit_button'

const { I18n } = window as any

type FormActionsProps = {
  accessControl: {
    canCancelOrder: boolean
    canEditOrder: boolean
    canSendOrder: boolean
    canApproveOrder: boolean
  }
  enableValidation: () => void
  disableValidation: () => void
  inputName: (name: string) => string
}
export default function FormActions(props: FormActionsProps) {
  const { accessControl, enableValidation, disableValidation, inputName } = props
  const { canCancelOrder, canEditOrder, canSendOrder, canApproveOrder } = accessControl

  const handleCancel = (e) => {
    disableValidation()
    if (!window.confirm(I18n.t('elements.actions.cancel_order_confirmation'))) {
      e.preventDefault()
    }
  }

  return (
    <div className="order-elements-form-actions">
      <SubmitButton
        enabled={canCancelOrder}
        className="send-order btn btn-secondary"
        name={inputName('status')}
        onClick={handleCancel}
        value="cancelled"
        content={I18n.t('elements.actions.cancel_order')}
      />

      <SubmitButton
        enabled={canSendOrder}
        className="send-order btn btn-secondary"
        name={inputName('status')}
        onClick={(_) => enableValidation()}
        value="approved"
        content={I18n.t('elements.actions.send_order')}
      />

      <SubmitButton
        enabled={canApproveOrder}
        className="approve-order btn btn-secondary"
        onClick={(_) => disableValidation()}
        name={inputName('status')}
        value="approved"
        content={I18n.t('elements.actions.approve_order')}
      />

      <SubmitButton
        enabled={canEditOrder}
        onClick={(_) => disableValidation()}
        className="btn btn-primary"
        name="commit"
        content={I18n.t('elements.actions.save_order')}
      />
    </div>
  )
}
